module.exports = __webpack_public_path__ + "img/favicon-pmp.bbe06d1f.png";